import { createReducer, on } from '@ngrx/store';
import {
  DELIVERY_ZONE_FIND_SUCCESS,
  DELIVERY_ZONE_FAILURE,
  DELIVERY_ZONE_UPDATE_FORM,
  DELIVERY_ZONE_RESET_ERROR,
  DELIVERY_ZONE_RESET,
  DELIVERY_ZONE_RESET_FORM,
  DELIVERY_ZONE_FIND_ALL_SUCCESS,
  DELIVERY_ZONE_EDIT_MODE,
  DELIVERY_ZONE_UPDATE_ID,
  DELIVERY_ZONE_UPDATE_LOADING,
  DELIVERY_ZONE_FIND_BY_LOCATION_SUCCESS,
  DELIVERY_ZONE_UPDATE_AVAILABLE
} from '../actions';
import { IResponseBadRequest } from '@core/interfaces';
import { DeliveryZone, DeliveryZoneForm } from '@core/models';

export interface DeliveryZoneState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  deliveryZone: DeliveryZone | null;
  deliveryZoneList: DeliveryZone[] | null;
  deliveryZoneForm: DeliveryZoneForm | null;
  deliveryZoneId: string | null;
  deliveryZoneAvailable: DeliveryZone[] | null;
  error: IResponseBadRequest | null;
}

export const initialState: DeliveryZoneState = {
  loading: false,
  editMode: false,
  isEditing: false,
  deliveryZone: null,
  deliveryZoneList: null,
  deliveryZoneForm: null,
  deliveryZoneId: null,
  deliveryZoneAvailable: null,
  error: null,
};
export const deliveryZoneReducer = createReducer(
  initialState,
  on(DELIVERY_ZONE_EDIT_MODE, (state, { editMode }) => ({ ...state, editMode })),
  on(DELIVERY_ZONE_FIND_SUCCESS, (state, { deliveryZone }) => ({ ...state, deliveryZone })),
  on(DELIVERY_ZONE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(DELIVERY_ZONE_FIND_ALL_SUCCESS, (state, { deliveryZoneList }) => ({ ...state, deliveryZoneList })),
  on(DELIVERY_ZONE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(DELIVERY_ZONE_UPDATE_FORM, (state, { deliveryZoneForm }) => ({ ...state, deliveryZoneForm })),
  on(DELIVERY_ZONE_UPDATE_AVAILABLE, (state, { deliveryZoneAvailable }) => ({ ...state, deliveryZoneAvailable })),
  on(DELIVERY_ZONE_RESET, (state) => ({ 
    ...state, 
    deliveryZone: null, 
  })),
  on(DELIVERY_ZONE_RESET_ERROR, (state) => ({ ...state, error: initialState.error })),
  on(DELIVERY_ZONE_RESET_FORM, (state) => ({ ...state, deliveryZoneForm: initialState.deliveryZoneForm, loading: initialState.loading })),
  on(DELIVERY_ZONE_UPDATE_ID, (state, { deliveryZoneId }) => ({ ...state, deliveryZoneId })),
  on(DELIVERY_ZONE_FIND_BY_LOCATION_SUCCESS, (state, { deliveryZone }) => ({ ...state, deliveryZone }))
);
